"use client"
import React from 'react';
import { Button, CardMedia } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const PaySubscription = () => {
    const navi = useNavigate();

    return (
        <Button
            color="warning"
            variant="outlined"
            onClick={() => navi('/signin')}
            sx={{ color: "#ED6C02" }}
        >
            Pay Subscription
        </Button>
    )
}

export default PaySubscription;